module.exports = __webpack_public_path__ + "static/media/release.37926f69.png";